<div class="loading-wrapper">
    <div class="loading-container">
        <div class="loading-progress"></div>
    </div>
</div>